export interface ServiceApp {
    clientId: string
    label: string
    tokenExpirySeconds: number
    accounts: string[]
    permissions: Record<string, string[]>
    createdAt: string | null
    lastUsedAt: string | null
}

export interface ServiceAppWithSecret extends ServiceApp {
    clientSecret: string
}

export interface NewServiceApp {
    label: string
    accounts: string[]
    permissions: Record<string, string[]>
    tokenExpirySeconds: number
}

export type ServiceAppErrorCode =
    | 'scope_exceeds_caller'
    | 'client_quota_exceeded'
    | 'validation_error'
    | 'not_found'
    | 'throttled'
    | 'unknown'

export class ServiceAppError extends Error {
    constructor(public code: ServiceAppErrorCode, message: string) {
        super(message)
        Object.setPrototypeOf(this, new.target.prototype)
    }
}

import { t } from 'translations'

export const SERVICE_APP_LIMIT = 25

const DAY_SECONDS = 86400

const NEVER_EXPIRES_SECONDS = 100 * 365 * DAY_SECONDS

export const getTokenExpiryOptions = () => [
    { value: String(90 * DAY_SECONDS), label: t('settings.personalSettings.serviceApps.tokenExpiry.days90') },
    { value: String(365 * DAY_SECONDS), label: t('settings.personalSettings.serviceApps.tokenExpiry.year1') },
    { value: String(NEVER_EXPIRES_SECONDS), label: t('settings.personalSettings.serviceApps.tokenExpiry.never') },
]

export const DEFAULT_TOKEN_EXPIRY_SECONDS = 90 * DAY_SECONDS

export const SERVICE_APP_CAPABILITIES = ['mcp']
